import 'i18next';
import { IsOptional } from 'class-validator';

export class ReportSettingsDto {
  @IsOptional()
  category: string | null = null;

  @IsOptional()
  journey: string | null = null;
}
